
import React, { useRef, useEffect, useState } from 'react';
import ImageWithBlur from './ImageWithBlur';

const About: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section id="about" className="py-20 bg-presintention-light section-padding" ref={sectionRef}>
      <div className="container-width">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image column */}
          <div className={`rounded-2xl overflow-hidden transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0 translate-x-8'}`}>
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-tr from-presintention-accent/20 to-transparent rounded-2xl transform rotate-3"></div>
              <img 
                src="/lovable-uploads/bae26bf0-366c-42e8-865d-bed867ea6e60.png"
                alt="Alex Fairlie - Presentation Coach"
                className="relative z-10 w-full h-[500px] object-cover rounded-2xl"
              />
              <div className="mt-2 text-center">
                <div className="flex items-center justify-center space-x-2">
                  <h3 className="font-bold text-lg text-presintention-dark">Alex Fairlie</h3>
                  <span className="text-presintention-dark/70">•</span>
                  <p className="text-presintention-dark/70">Presentation Coach</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content column */}
          <div>
            <span className={`inline-block px-3 py-1 bg-presintention-accent/10 text-presintention-accent rounded-full text-sm font-medium mb-4 transition-all duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
              About Me
            </span>
            
            <h2 className={`text-3xl md:text-4xl font-bold mb-6 transition-all duration-700 delay-100 text-presintention-dark ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-4'}`}>
              About <span className="text-presintention-accent">Me</span>
            </h2>
            
            <div className={`space-y-6 text-presintention-dark/70 transition-all duration-700 delay-200 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-4'}`}>
              <p>
                Hi I'm Alex Fairlie, and I've always been deeply interested in studying human behavior. I find it fascinating to uncover the inner workings of a person and understand what truly drives them. It's a passion that has driven me to pursue a variety of paths in life, from acting and directing to sales, management, and training.
              </p>
              
              <p>
                I wasn't a natural born communicator but I have always been driven to understand situations and find solutions. I wanted to find a way to help people by combining my passions for performing and human behavior, which ultimately led me to become a presentation coach.
              </p>
              
              <p>
                With 20+ years as an actor, a decade leading training sessions and delivering sales presentations, and certification in nonverbal communication, I help you master both your message and delivery—ensuring your words resonate authentically.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
